import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { Logo } from "@/components/Logo";
import { COMPANY } from "@/lib/data";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#071A33] text-white">
      <div className="mx-auto max-w-[1200px] px-5 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-3 md:items-start">
          <div>
            <Link to="/" aria-label="Home">
              <Logo variant="light" />
            </Link>
          </div>

          <div className="space-y-4 md:border-l md:border-white/12 md:pl-10">
            <a href={COMPANY.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 text-[15px] text-white/85 transition-colors hover:text-white">
              <Phone size={18} className="text-[#4E86F0]" /> {COMPANY.phone}
            </a>
            <a href={COMPANY.emailHref} data-testid="footer-email" className="flex items-center gap-3 break-all text-[15px] text-white/85 transition-colors hover:text-white">
              <Mail size={18} className="text-[#4E86F0]" /> {COMPANY.email}
            </a>
            <div className="flex items-center gap-3 text-[15px] text-white/85">
              <MapPin size={18} className="text-[#4E86F0]" /> {COMPANY.area}
            </div>
          </div>

          <div className="md:border-l md:border-white/12 md:pl-10">
            <p className="font-display font-bold tracking-wide">Follow Us</p>
            <a
              href={COMPANY.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              aria-label="Facebook"
              className="mt-4 inline-flex h-11 w-11 items-center justify-center rounded-full bg-[#1877F2] transition-transform hover:scale-105"
            >
              <Facebook size={22} className="text-white" fill="white" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <p className="mx-auto max-w-[1200px] px-5 lg:px-8 py-5 text-center text-[13px] text-white/55">
          © 2024 {COMPANY.name}, LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
